<ion-content
  #content
  [class]="dataServ.rData ? dataServ.rData.hotel_type : ''"
  *ngIf="dataServ.menuSection && dataServ.menuItem && didInit && onDidInit"
>
  <ion-header>
    <ion-toolbar>
      <ion-back-button
        *ngIf="!blankPage"
        [color]="
          !sliderDisplay || !dataServ.menuItem?.images ? 'dark' : 'white'
        "
        slot="start"
        defaultHref="/home"
        text=""
        icon="chevron-back"
      ></ion-back-button>

      <ion-title>
        <ion-text
          [color]="
            !sliderDisplay || !dataServ.menuItem?.images ? 'dark' : 'white'
          "
          class="ion-text-center"
        >
          <h1>{{ dataServ.menuItem.name | caption | translate }}</h1>
        </ion-text>
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-grid
    class="content-grid {{
      sliderDisplay &&
      dataServ.menuItem.images &&
      dataServ.menuItem.images.length > 0
        ? ''
        : 'slider-none'
    }} {{ horizontalSlide ? 'horizontal-content-grid' : '' }}"
  >
    <ion-row
      class="{{
        canReserve ||
        (dataServ.menuSection.id === 105 &&
          (dataServ.rData.online_reservation_url | caption))
          ? 'w-reservation'
          : ''
      }}"
    >
      <swiper #slider mode="ios" pager="ios" [config]="config">
        <ng-container *ngIf="dataServ.rData && didInit">
          <ng-container *ngFor="let img of categorizedSlider">
            <ng-container>
              <ng-template swiperSlide>
                <ng-container
                  *ngIf="
                    ['mp4', 'avi', 'webm', 'flv', 'mov'].includes(img.type);
                    else imageSlider
                  "
                >
                  <video
                    [poster]="img.url"
                    loop
                    autoplay
                    [muted]="true"
                    [controls]="false"
                    playsInline
                  >
                    <source [src]="img.url" type="video/mp4" />
                    <img [src]="img.url" #divideImg />
                  </video>
                </ng-container>

                <ng-template #imageSlider>
                  <img [src]="img.url" #divideImg />
                </ng-template>
              </ng-template>
            </ng-container>
          </ng-container>
        </ng-container>
      </swiper>

      <ng-container *ngIf="monoSlide">
        <img
          [src]="dataServ.menuItem.images[0].url"
          alt=""
          class="mono-slide"
        />
      </ng-container>

      <ion-col size="12">
        <div class="safe-area"></div>
      </ion-col>
    </ion-row>

    <ion-row>
      <!-- <ion-col size="12" class="playbutton">
        <ion-icon name="play" color="primary"></ion-icon>
      </ion-col> -->
    </ion-row>

    <ion-row class="bottom-row">
      <!-- <ion-col size="12" (click)="scrollDetail()" *ngIf="!horizontalSlide">
        <ion-text color="white" class="mb-1">
          <h1>{{ "Details" | translate }}</h1>
          <ion-icon name="chevron-down"></ion-icon>
        </ion-text>
      </ion-col> -->

      <ion-col size="12">
        <ng-container *ngIf="dataServ.menuSection.id !== 105; else room">
          <ion-button
            label="reservation"
            [disabled]="processing"
            color="primary"
            *ngIf="canReserve && dataServ.requestActive"
            (click)="reservation()"
          >
            <div class="square" appEqualWidthHeight equalWith="height">
              <ion-icon name="calendar-outline" color="primary"></ion-icon>
            </div>
            {{ "Reservation" | translate }}
          </ion-button>
        </ng-container>

        <ng-template #room>
          <ion-button
            [disabled]="processing"
            color="primary"
            (click)="resButton()"
            *ngIf="dataServ.rData.online_reservation_url | caption"
          >
            <div class="square" appEqualWidthHeight equalWith="height">
              <ion-icon name="calendar-outline" color="primary"></ion-icon>
            </div>
            {{ "Reservation" | translate }}
          </ion-button>
        </ng-template>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-grid class="description-grid" *ngIf="dataServ.menuItem">
    <ion-row
      class="buttons"
      *ngIf="
        dataServ.menuItem.show_follow ||
        dataServ.menuItem.show_phone_number ||
        dataServ.menuItem.activate_map_location ||
        dataServ.menuItem.show_whatsapp ||
        dataServ.menuItem.web_site_url ||
        (dataServ.menuItem.menu_item_books &&
          dataServ.menuItem.menu_item_books.length > 0 &&
          !workingHoursDisplay) ||
        (dataServ.menuItem.show_virtual_tour &&
          (dataServ.menuItem.virtual_tour_url | caption)) ||
        (dataServ.menuItem.show_survey && authServ.isLogged) ||
        surveyLink
      "
    >
      <ion-col
        size="2"
        *ngIf="dataServ.menuItem.show_follow && authServ.isLogged"
      >
        <ion-button
          label="follow"
          appEqualWidthHeight
          equalWith="width"
          (click)="follow()"
          [color]="
            (dataServ.menuItem.id | followControl) ? 'primary' : 'medium'
          "
          *ngIf="dataServ.menuItem.show_follow && !processing"
        >
          <ion-icon slot="icon-only" name="notifications-outline"></ion-icon>
        </ion-button>
        <ion-spinner
          name="lines"
          *ngIf="processing"
          class="follow-spinner"
        ></ion-spinner>
      </ion-col>

      <ion-col size="2" *ngIf="dataServ.menuItem.show_email">
        <ion-button
          label="email"
          appEqualWidthHeight
          equalWith="width"
          href="mailto:{{ dataServ.menuItem.email }}"
        >
          <ion-icon slot="icon-only" name="mail-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col size="2" *ngIf="dataServ.menuItem.show_phone_number">
        <ion-button
          label="call"
          appEqualWidthHeight
          equalWith="width"
          href="tel:{{ dataServ.menuItem.phone }}"
        >
          <ion-icon slot="icon-only" name="call-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col size="2" *ngIf="dataServ.menuItem.show_whatsapp">
        <ion-button
          label="mesage"
          appEqualWidthHeight
          equalWith="width"
          href="https://wa.me/{{ dataServ.menuItem.whatsapp }}"
        >
          <ion-icon slot="icon-only" name="logo-whatsapp"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col size="2" *ngIf="surveyLink">
        <ion-button appEqualWidthHeight equalWith="width" [href]="surveyLink">
          <ion-icon slot="icon-only" name="star-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col
        size="2"
        *ngIf="
          dataServ.menuItem.show_survey &&
          dataServ.menuItem.survey_title &&
          authServ.isLogged &&
          !surveyLink
        "
      >
        <ion-button
          label="survey"
          appEqualWidthHeight
          equalWith="width"
          (click)="modalServ.survey(dataServ.menuItem, 'item')"
        >
          <ion-icon slot="icon-only" name="star-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col
        size="2"
        *ngIf="
          dataServ.menuItem.menu_item_books &&
          dataServ.menuItem.menu_item_books.length > 0 &&
          !workingHoursDisplay
        "
      >
        <ion-button
          appEqualWidthHeight
          equalWith="width"
          (click)="modalServ.schedule(dataServ.menuItem)"
        >
          <ion-icon slot="icon-only" name="time-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col
        size="2"
        *ngIf="
          dataServ.menuItem.activate_map_location &&
          dataServ.menuItem.map_location
        "
      >
        <ion-button
          label="google_map_directions"
          appEqualWidthHeight
          equalWith="width"
          href="https://www.google.com/maps/dir/?api=1&destination={{
            dataServ.menuItem.map_location
          }}"
          target="_blank"
        >
          <ion-icon slot="icon-only" name="location-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col size="2" *ngIf="dataServ.menuItem.web_site_url">
        <ion-button
          label="website"
          appEqualWidthHeight
          equalWith="width"
          (click)="modalServ.openLink(dataServ.menuItem.web_site_url)"
        >
          <ion-icon slot="icon-only" name="earth-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col
        size="2"
        *ngIf="
          dataServ.menuItem.show_virtual_tour &&
          (dataServ.menuItem.virtual_tour_url | caption)
        "
      >
        <ion-button
          label="virtual_tour"
          appEqualWidthHeight
          equalWith="width"
          (click)="modalServ.openLink(dataServ.menuItem.virtual_tour_url)"
        >
          <ion-icon slot="icon-only" name="image-outline"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-row class="description">
      <ng-container *ngIf="dataServ.menuItem.description | caption | translate">
        <ion-col size="12">
          <ion-text color="primary">
            <h1>{{ "Details" | translate }}:</h1>
          </ion-text>
        </ion-col>

        <ion-col size="12">
          <ion-text color="dark">
            <p
              [innerHtml]="dataServ.menuItem.description | caption | translate"
              appInternalLinks
            ></p>
          </ion-text>
        </ion-col>
      </ng-container>

      <ng-container *ngIf="dataServ.menuItem.show_dress_code">
        <ion-col size="12">
          <ion-item class="ion-no-border">
            <ion-icon slot="start" name="shirt-outline"></ion-icon>
            <ion-label>
              <b>{{ "Dress Code" | translate }}</b> <br />
              {{ dataServ.menuItem.dress_code | caption | translate }}
            </ion-label>
          </ion-item>
        </ion-col>
      </ng-container>

      <ng-container *ngIf="dataServ.menuItem.show_title_and_description">
        <ion-col size="12">
          <ion-text color="dark">
            <ul class="title-desc">
              <ng-container>
                <li
                  *ngFor="
                    let bullet of dataServ.menuItem
                      .menu_item_title_and_descriptions
                  "
                >
                  <b [innerHtml]="bullet.title | caption | translate"></b>
                  <br />
                  <span
                    [innerHtml]="bullet.description | caption | translate"
                  ></span>
                </li>
              </ng-container>
            </ul>
          </ion-text>
        </ion-col>
      </ng-container>

      <ng-container *ngIf="dataServ.menuItem.show_bullet_list">
        <ion-col size="12">
          <ion-text color="dark">
            <ul>
              <ng-container
                *ngFor="let bullet of dataServ.menuItem.menu_item_bullet_lists"
              >
                <li *ngIf="bullet.title | caption | translate">
                  <span [innerHtml]="bullet.title | caption | translate"></span>
                </li>
              </ng-container>
            </ul>
          </ion-text>
        </ion-col>
      </ng-container>

      <ng-container
        *ngIf="
          dataServ.menuItem.menu_item_books &&
          dataServ.menuItem.menu_item_books.length > 0
        "
      >
        <ion-col size="12">
          <ion-text
            color="primary"
            *ngIf="workingHoursDisplay"
            class="ion-text-center"
          >
            <h3>
              {{ "Working Hours" | translate }} <br />

              {{
                dataServ.menuItem.menu_item_books[0].menu_item_book_details[0]
                  .start_time | overrideTimezone : dataServ.rData.time_zone
              }}
              -
              {{
                dataServ.menuItem.menu_item_books[0].menu_item_book_details[0]
                  .end_time | overrideTimezone : dataServ.rData.time_zone
              }}
            </h3>
          </ion-text>

          <ion-button
            label="timetable"
            size="large"
            class="schedule"
            (click)="modalServ.schedule(dataServ.menuItem)"
            expand="block"
            fill="clear"
            *ngIf="!workingHoursDisplay"
          >
            {{ "See Full Schedule" | translate }}
          </ion-button>
        </ion-col>
      </ng-container>

      <!-- <ng-container
        *ngIf="
          authServ.isLogged &&
          !catalogDisplay &&
          !canReserve &&
          dataServ.menuItem.form_fields &&
          dataServ.menuItem.form_fields.length > 0
        "
      >
        <ion-col size="12">
          <ion-text color="primary" class="ion-text-center">
            <h3 class="ion-no-margin">
              <b>{{ "Request" | translate }}</b>
            </h3>
          </ion-text>
        </ion-col>

        <app-extra-forms></app-extra-forms>

        <ion-col size="12">
          <ion-button
            label="extra_form_send"
            (click)="sendForm()"
            expand="block"
            color="primary"
            [disabled]="processing"
          >
            <ion-spinner
              name="lines"
              slot="start"
              *ngIf="processing"
            ></ion-spinner>
            {{ "Send" | translate }}
          </ion-button>
        </ion-col>
      </ng-container> -->

      <ng-container *ngIf="pdfLinks && pdfLinks.length > 0">
        <ion-col size="12">
          <ion-segment
            mode="md"
            [(ngModel)]="currentPdf"
            (ionChange)="refresh(); updateSegment()"
            scrollable
            #menuSegment
          >
            <ion-segment-button [value]="pdf.url" *ngFor="let pdf of pdfLinks">
              <ion-label>{{ pdf.name | caption | translate }}</ion-label>
            </ion-segment-button>
          </ion-segment>
        </ion-col>
        <ion-col size="12" *ngIf="currentPdf">
          <ion-button
            label="open_pdf"
            (click)="openPdf(currentPdf, currentPdfType)"
            expand="block"
            class="pdf-btn"
          >
            <ng-container *ngIf="openPdfCaptionDisplay; else default">
              {{ "Open Pdf" | translate }}
            </ng-container>
            <ng-template #default>
              {{ "Open Menu" | translate }}
            </ng-template>
          </ion-button>
        </ion-col>
        <ion-col size="12" *ngIf="pdfDisplay">
          <!-- PDF Viewer for Non-iOS Devices -->
          <div 
            *ngIf="didInit && !processing && !isIos" 
            class="pdf-container"
          >
            <iframe
              #pdfIframe
              allowfullscreen
              scrolling="auto"
              [src]="getPdfViewerUrl(currentPdf) | safeUrl"
              class="pdf-viewer"
              (load)="onPdfLoad()"
              (error)="onPdfError()"
            ></iframe>
            
            <!-- Fallback link if iframe fails -->
            <div *ngIf="pdfLoadError" class="pdf-fallback">
              <ion-card>
                <ion-card-content class="ion-text-center">
                  <ion-icon name="document-outline" size="large" color="medium"></ion-icon>
                  <h3>{{ "PDF could not be loaded" | translate }}</h3>
                  <ion-button 
                    (click)="openPdfExternal(currentPdf)" 
                    fill="outline" 
                    color="primary"
                  >
                    {{ "Open in External Viewer" | translate }}
                  </ion-button>
                </ion-card-content>
              </ion-card>
            </div>
          </div>

          <!-- PDF Viewer for iOS Devices -->
          <div 
            *ngIf="didInit && !processing && isIos" 
            class="pdf-container"
          >
            <object
              width="100%"
              height="100%"
              [data]="currentPdf | safeUrl"
              type="application/pdf"
              class="pdf-viewer"
            >
              <!-- Fallback for iOS if object fails -->
              <div class="pdf-fallback">
                <ion-card>
                  <ion-card-content class="ion-text-center">
                    <ion-icon name="document-outline" size="large" color="medium"></ion-icon>
                    <h3>{{ "PDF could not be loaded" | translate }}</h3>
                    <ion-button 
                      (click)="openPdfExternal(currentPdf)" 
                      fill="outline" 
                      color="primary"
                    >
                      {{ "Open in External Viewer" | translate }}
                    </ion-button>
                  </ion-card-content>
                </ion-card>
              </div>
            </object>
          </div>

          <!-- Loading Spinner -->
          <div *ngIf="processing" class="pdf-loading">
            <ion-spinner name="lines" class="pdf-spinner"></ion-spinner>
            <p class="ion-text-center">{{ "Loading PDF..." | translate }}</p>
          </div>
        </ion-col>
      </ng-container>

      <ng-container
        *ngIf="dataServ.menuItem.videos && dataServ.menuItem.videos.length > 0"
      >
        <ion-col size="12" *ngFor="let video of dataServ.menuItem.videos">
          <video controls [src]="video.url"></video>
        </ion-col>
      </ng-container>

      <ion-col size="12" *ngIf="dataServ.menuItem.youtube">
        <!-- ngx-youtube-player is deprecated. Use @angular/youtube-player instead. -->
        <!-- <youtube-player [videoId]="dataServ.menuItem.youtube.split('v=')[1]" style="width: 100%; margin: auto">
        </youtube-player> -->
        <youtube-player
          [videoId]="dataServ.menuItem.youtube.split('v=')[1]"
          style="width: 100%; margin: auto"
        ></youtube-player>
      </ion-col>

      <ion-col size="12" *ngIf="catalogDisplay">
        <app-catalog></app-catalog>
      </ion-col>

      <!-- <div class="watermark">
        <img src="assets/img/logo-outline.svg" alt="Relax Resort" />
      </div> -->
    </ion-row>

    <ion-row
      class="gallery"
      *ngIf="
        dataServ.menuItem.images &&
        dataServ.menuItem.images.length > 1 &&
        sliderDisplay
      "
    >
      <ion-col size="3">
        <div class="square"></div>
        <ion-text color="secondary">
          <h5>{{ "Gallery" | translate }}</h5>
        </ion-text>
      </ion-col>
      <ion-col
        size="7"
        *ngFor="
          let img of categorizedSlider;
          let first = first;
          let sIndex = index
        "
        [class]="first ? 'first' : ''"
      >
        <!-- <ion-img *ngIf="img.type !== ('mp4' || 'avi' || 'webm' || 'flv' || 'mov')" (click)="fullPageSlider.initialSlide = sIndex; fullImage = true" [src]="img.url"></ion-img> -->

        <ng-container
          *ngIf="
            ['mp4', 'avi', 'webm', 'flv', 'mov'].includes(img.type);
            else imageSlider
          "
        >
          <video
            (click)="fullPageSlider.initialSlide = sIndex; fullImage = true"
            [poster]="img.url"
            loop
            autoplay
            [muted]="true"
            [controls]="false"
            playsInline
          >
            <source [src]="img.url" type="video/mp4" />
            <img [src]="img.url" #divideImg />
          </video>
        </ng-container>

        <ng-template #imageSlider>
          <img
            (click)="fullPageSlider.initialSlide = sIndex; fullImage = true"
            [src]="img.url"
          />
        </ng-template>
      </ion-col>
    </ion-row>

    <!-- MAP -->

    <!-- <ion-row>
      <ion-col size="12" *ngIf="dataServ.menuItem.show_location_description">
        <ion-text color="primary">
          <b>{{ "Address" | translate }}</b
          >: <br />
          {{ dataServ.menuItem.location_description | caption | translate }}
        </ion-text>
      </ion-col>
      <ion-col
        size="12"
        *ngIf="
          dataServ.menuItem.activate_map_location &&
          dataServ.menuItem.map_location
        "
      >
        <div id="map" appEqualWidthHeight equalWith="width"></div>
      </ion-col>
    </ion-row> -->

    <!-- MAP -->
  </ion-grid>
</ion-content>

<ion-footer *ngIf="cartServ.totalCount > 0">
  <ion-row class="cart">
    <ion-col size="9">
      <ion-text color="light">
        <b>{{ cartServ.totalCount }} {{ "Items" | translate }}</b>
      </ion-text>
    </ion-col>
    <ion-col size="3">
      <ion-button
        [disabled]="processing"
        (click)="cart()"
        expand="block"
        fill="clear"
        color="white"
      >
        {{ "Next" | translate }}
      </ion-button>
    </ion-col>
  </ion-row>
</ion-footer>

<div class="full-img" *ngIf="fullImage">
  <div class="bg-overlay" (click)="fullImage = false"></div>
  <ion-icon
    class="close"
    name="close"
    color="white"
    (click)="fullImage = false"
  ></ion-icon>
  <ion-slides mode="ios" pager="ios" zoom [options]="fullPageSlider">
    <ion-slide *ngFor="let img of categorizedSlider">
      <ng-container
        *ngIf="
          ['mp4', 'avi', 'webm', 'flv', 'mov'].includes(img.type);
          else imageSlider
        "
      >
        <video
          class="video70"
          [poster]="img.url"
          loop
          autoplay
          [muted]="true"
          [controls]="false"
          playsInline
        >
          <source [src]="img.url" type="video/mp4" />
          <img [src]="img.url" #divideImg />
        </video>
      </ng-container>

      <ng-template #imageSlider>
        <img [src]="img.url" />
      </ng-template>
    </ion-slide>
  </ion-slides>
</div>
